import { createAsyncAction } from "../helpers";

export const getLinksListAsyncAction = createAsyncAction(
	"GET_YOUTUBE_LINKS_LIST_REQUEST",
	"GET_YOUTUBE_LINKS_LIST_SUCCESS",
	"GET_YOUTUBE_LINKS_LIST_FAILURE",
	"GET_YOUTUBE_LINKS_LIST_CANCEL"
);

export const postLinksManyAsyncAction = createAsyncAction(
	"POST_YOUTUBE_LINKS_MANY_REQUEST",
	"POST_YOUTUBE_LINKS_MANY_SUCCESS",
	"POST_YOUTUBE_LINKS_MANY_FAILURE",
	"POST_YOUTUBE_LINKS_MANY_CANCEL"
);

export const truncateLinksAsyncAction = createAsyncAction(
	"TRUNCATE_YOUTUBE_LINKS_REQUEST",
	"TRUNCATE_YOUTUBE_LINKS_SUCCESS",
	"TRUNCATE_YOUTUBE_LINKS_FAILURE",
	"TRUNCATE_YOUTUBE_LINKS_CANCEL"
);
